import { render, staticRenderFns } from "./test.vue?vue&type=template&id=06bc6123&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "./test.vue?vue&type=style&index=0&id=06bc6123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc6123",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bc6123')) {
      api.createRecord('06bc6123', component.options)
    } else {
      api.reload('06bc6123', component.options)
    }
    module.hot.accept("./test.vue?vue&type=template&id=06bc6123&scoped=true&", function () {
      api.rerender('06bc6123', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/test.vue"
export default component.exports